
<div class="striped-rows flex-md-last flex-lg-first">
    <div class="row">
        <div class="col-md-12 col-lg-3"></div>
        <div class="col-md-12 col-lg-9"></div>
    </div>
    <div *ngIf="canViewItemPackets" class="row push-down">
        <div class="col-md-12 col-lg-3">
            <strong>Item Packets:</strong>
        </div>
        <div class="col-md-12 col-lg-9">
            <item-packet-pills [userEntries]="filteredItemPackets" [showTitle]="true"></item-packet-pills>
        </div>
    </div>
    <div class="row push-down">
        <div class="col-md-12 col-lg-3">
            <strong>Description:</strong>
        </div>
        <div class="col-md-12 col-lg-9">
            {{ complianceItem.Description }}
        </div>
    </div>
    <div class="row push-down">
        <div class="col-md-12 col-lg-3">
            <strong>Start Date:</strong>
        </div>
        <div class="col-md-12 col-lg-9">
            {{ userCycle.StartDate | dateExtended: 'MMMM dd, yyyy' }}
        </div>
    </div>
    <div class="row push-down">
        <div class="col-md-12 col-lg-3">
            <strong>End Date:</strong>
        </div>
        <div class="col-md-12 col-lg-9">
            {{ userCycle.EndDate | dateExtended: 'MMMM dd, yyyy' }}
        </div>
    </div>
    <div class="row push-down">
        <div class="col-md-12 col-lg-3" >
            <strong>Days Remaining:</strong>
        </div>
        <div class="col-md-12 col-lg-9"[ngClass]="{ 'expired' : Negative(userCycle) }">
            <td>{{daysRemaining(userCycle)}}</td>
        </div>
    </div>
    <div class="row push-down">
        <div class="col-md-12 col-lg-3">
            <strong>Recurrence:</strong>
        </div>
        <div class="col-md-12 col-lg-9">
            {{ complianceItem | recurrenceSummaryFilter }}
        </div>
    </div>
    <div class="row push-down">
        <div class="col-md-12 col-lg-3">
            <strong>Instructions:</strong>
        </div>
        <div class="col-md-12 col-lg-9 instructions" [innerHtml]="instructions"></div>
    </div>
    <div class="row push-down">
        <div class="col-md-12 col-lg-3">
            <strong>Resource Links:</strong>
        </div>
        <div class="col-md-12 col-lg-9">
            <span *ngIf="complianceItem.Resources.length === 0">-</span>
            <ul class="links" *ngIf="complianceItem.Resources.length > 0">
                <li *ngFor="let resource of complianceItem.Resources">
                    <a [href]="resource.Link" [innerHtml]="resource.Alias" target="_blank"></a>
                </li>
            </ul>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 col-lg-3">
            <strong>Attachments:</strong>
        </div>
        <div class="col-md-12 col-lg-9">
            <span *ngIf="complianceItem.Attachments.length === 0">-</span>
            <ul class="links" *ngIf="complianceItem.Attachments.length > 0">
                <li *ngFor="let attachment of complianceItem.Attachments">
                    <i class="fas fa-paperclip"></i> <button type="button" class="btn btn-link" [innerHtml]="attachment.FileName" (click)="viewAttachement(attachment)"></button>
                </li>
            </ul>
        </div>
    </div>
    <div class="row push-down">
        <div class="col-md-12 col-lg-3">
            <strong>Person of Contact:</strong>
        </div>
        <div class="col-md-12 col-lg-9">
            <span *ngIf="(complianceItem.AssignedUsers | userAssignmentFilter:UserAssignment.CONTACTUSER).length === 0">-</span>
            <ul class="contacts" *ngIf="(complianceItem.AssignedUsers | userAssignmentFilter:UserAssignment.CONTACTUSER).length > 0">
                <li *ngFor="let assignedUser of complianceItem.AssignedUsers | userAssignmentFilter:UserAssignment.CONTACTUSER">
                    <a href="mailto:{{ assignedUser.Email }}" [innerHtml]="assignedUser.DisplayName"></a>
                </li>
            </ul>
        </div>
    </div>
    <div class="row push-down" *ngIf="complianceItem.VerificationStages.length > 0">
        <div class="col-md-12 col-lg-3">
            <strong>Approval Stages</strong>
        </div>
        <div class="col-md-12 col-lg-9">
            <ul>
                <li *ngFor="let verificationStage of complianceItem.VerificationStages">
                    <ng-template #approverContent>
                        <ul class="assigned-users">
                            <li *ngFor="let assignedUsers of verificationStage.Approvers">
                                {{ assignedUsers.FirstName }} {{ assignedUsers.LastName }}
                            </li>
                        </ul>
                    </ng-template>
                    {{ verificationStage.StageName }}
                    <i class="fas fa-info-circle" aria-hidden="true"
                        [ngbPopover]="approverContent" popoverTitle="Approvers"
                        triggers="mouseenter:mouseleave"></i>
                </li>
            </ul>
        </div>
    </div>
    <div class="row push-down" *ngIf="isFlexEnabled()">
        <div class="col-md-12 col-lg-3">
            <strong>Flex</strong>
        </div>
        <div class="col-md-12 col-lg-9 d-flex align-items-center">
            <div>Hours: {{getFlexHours}}</div>
        </div>
    </div>
    <div class="row push-down" *ngIf="isAct48Enabled()">
            <div class="col-md-12 col-lg-3">
                <strong>Act 48</strong>
            </div>
            <div class="col-md-12 col-lg-9">
                    <timetracking-status-indicator
                        [statusId]="userCycle.A48SubmissionStatus"
                        [paraStatusId]="userCycle.ParaStatus"
                        [isPara]="userCycle.IsPara"
                        [paraApplicable]="complianceItem.Act48Detail.ParaApplicable"
                        [a48ContextCode]="userCycle.A48ContextCode"
                        [timeTrackingType]="TimeTrackingType.ACT48"
                        statusLabel="Act 48 Submission"
                        [hours]="getA48Hours()"
                        [activityType]="getActivityType()"
                        [showHours]="true">
                    </timetracking-status-indicator>
                    <div>Status: {{getSubmissionStatus()}}</div>
                    <div>{{a48HelpersService.getHoursOrCreditsFullLabel(complianceItem.Act48Detail.ActivityType)}}: {{getA48Hours()}}</div>
                    <div>Provider: {{complianceItem.Act48Detail.Provider}}</div>
                    <div *ngIf="A48Labels.AUNLabel">AUN: {{A48Labels.AUNLabel}}</div>
                    <div>Activity Type: {{A48Labels.ActivityType}}</div>
                    <div>Course Type: {{A48Labels.CourseType}}</div>
                    <div *ngIf="A48Labels.CollegeCreditType">College Credit Type: {{A48Labels.CollegeCreditType}}</div>
                    <div *ngIf="complianceItem.Act48Detail.ParaApplicable">CEC Performance Based Standard: {{A48Labels.CECPerformanceStandard}}</div>
            </div>
        </div>
</div>
